<section class="shopee-lazada-video-wrapper">
  <div class="box-container">
    <div class="box">
      <div class="box__left">
        <!-- desktop heading -->
        <div class="box__heading color-gray box__heading--desktop">
          <q [innerHTML]="'SHOPEE_LAZADA.VIDEO.HEADING' | translate"></q>
        </div>

        <!-- tablet heading -->
        <div class="box__heading color-gray box__heading--tablet">
          <q [innerHTML]="'SHOPEE_LAZADA.VIDEO.HEADING_TABLET' | translate"> </q>
        </div>

        <!-- mobile heading -->
        <div class="box__heading color-gray box__heading--mobile">
          <q [innerHTML]="'SHOPEE_LAZADA.VIDEO.HEADING_MOBILE' | translate"> </q>
        </div>

        <div class="box__link">
          <div class="speaker">{{ 'SHOPEE_LAZADA.VIDEO.SPEAKER' | translate }}</div>
          <div class="speaker-job">{{ 'SHOPEE_LAZADA.VIDEO.JOB' | translate }}</div>
        </div>
      </div>
      <div class="box__right">
        <div class="box__item" (click)="linkVideo('reYQJ4_DCmo')" data-toggle="modal" data-target="#functionVideo">
          <div class="box__item-cover">
            <div class="box__item-cover--bg"></div>
            <picture>
              <source
                srcset="
                  https://flowaccountcdn.com/new_landing/image/functions/shopee_laz/section3/FlowAccount_Testimonial_th_v3.webp
                "
                type="image/webp"
              />
              <img
                src="https://flowaccountcdn.com/new_landing/image/functions/shopee_laz/section3/FlowAccount_Testimonial_th_v3.jpg"
                class="box__image"
                alt="ทำบัญชีร้านค้าออนไลน์"
                title="ทำบัญชีร้านค้าออนไลน์"
                loading="lazy"
              />
            </picture>

            <div class="box__item-cover--icon">
              <picture>
                <source
                  srcset="https://flowaccountcdn.com/new_landing/image/mobile/Tutorial/Play_button.png"
                  type="image/webp"
                />
                <source
                  srcset="https://flowaccountcdn.com/new_landing/image/mobile/Tutorial/Play_button.png"
                  type="image/jpeg"
                />
                <img
                  src="https://flowaccountcdn.com/new_landing/image/mobile/Tutorial/Play_button.png"
                  class="icon-play"
                  alt="FlowAccount Testimonials"
                  loading="lazy"
                />
              </picture>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
